import auth0 from "auth0-js";
import Vue from "vue";
var configSettings = require("../config/config.json");

// Determine the redirect URI with proper fallback logic
let redirectUri;

// For client-side apps in Static Web Apps, always use window.location.origin
// This ensures the redirect works regardless of the domain
if (typeof window !== "undefined") {
   redirectUri = window.location.origin + "/callback";
}
// Server-side rendering fallback: Environment variable
else if (process.env.VUE_APP_AUTH_REDIRECT_URL) {
   redirectUri = process.env.VUE_APP_AUTH_REDIRECT_URL + "/callback";
}
// Config file fallback (if it's not a placeholder)
else if (configSettings.SITE_URL && !configSettings.SITE_URL.includes("DEFAULT_SITE_URL")) {
   redirectUri = configSettings.SITE_URL + "/callback";
}
// Final fallback for SSR: Default production URL
else {
   redirectUri = "https://myeconomy-site.azurewebsites.net/callback";
}

// Additional safety check
if (redirectUri === "undefined/callback" || redirectUri.includes("DEFAULT_SITE_URL")) {
   if (typeof window !== "undefined") {
      redirectUri = window.location.origin + "/callback";
   } else {
      redirectUri = "https://myeconomy-site.azurewebsites.net/callback";
   }
}

// Debug logging
// eslint-disable-next-line
console.log("Auth0 Configuration:");
// eslint-disable-next-line
console.log("  VUE_APP_AUTH_REDIRECT_URL:", process.env.VUE_APP_AUTH_REDIRECT_URL);
// eslint-disable-next-line
console.log("  Config SITE_URL:", configSettings.SITE_URL);
// eslint-disable-next-line
console.log("  Final redirectUri:", redirectUri);
// eslint-disable-next-line
console.log("  window.location.origin:", typeof window !== "undefined" ? window.location.origin : "N/A");

// exchange the object with your own from the setup step above.
let webAuth = new auth0.WebAuth({
   domain: "skaanvik.auth0.com",
   clientID: "BySJpfYN4r0M53ll2yk1DyCa6yBd0Pwz",
   redirectUri: redirectUri,
   responseType: "token id_token",
   scope: "openid profile email",
   // we will use the api/v2/ to access the user information as payload
   audience: "https://" + "skaanvik.auth0.com" + "/api/v2/",
});

let auth = new Vue({
   computed: {
      token: {
         get: function () {
            return localStorage.getItem("id_token");
         },
         set: function (id_token) {
            localStorage.setItem("id_token", id_token);
         },
      },
      accessToken: {
         get: function () {
            return localStorage.getItem("access_token");
         },
         set: function (accessToken) {
            localStorage.setItem("access_token", accessToken);
         },
      },
      expiresAt: {
         get: function () {
            return localStorage.getItem("expires_at");
         },
         set: function (expiresIn) {
            let expiresAt = JSON.stringify(expiresIn * 1000 + new Date().getTime());
            localStorage.setItem("expires_at", expiresAt);
            if (configSettings.debug) {
               // eslint-disable-next-line
               alert("expiresIn :" + expiresAt);
            }
         },
      },
      user: {
         get: function () {
            return JSON.parse(localStorage.getItem("user"));
         },
         set: function (user) {
            localStorage.setItem("user", JSON.stringify(user));
         },
      },
   },
   methods: {
      login() {
         webAuth.authorize();
      },
      getIdToken() {
         return localStorage.getItem("id_token");
      },
      getUser() {
         return JSON.parse(localStorage.getItem("user"));
      },
      logout() {
         localStorage.removeItem("access_token");
         localStorage.removeItem("id_token");
         localStorage.removeItem("expires_at");
         localStorage.removeItem("user");
         webAuth.authorize();
      },
      isAuthenticated() {
         let result = new Date().getTime() < this.expiresAt;
         if (!result) {
            //  alert('isAuthenticated :'+this.expiresAt)
         } else {
            if (configSettings.debug) {
               // eslint-disable-next-line
               console.log("isAuthenticated :" + this.expiresAt);
            }
         }
         return result;
      },
      handleAuthentication() {
         return new Promise((resolve, reject) => {
            webAuth.parseHash((err, authResult) => {
               if (authResult && authResult.accessToken && authResult.idToken) {
                  this.expiresAt = authResult.expiresIn;
                  this.accessToken = authResult.accessToken;
                  this.token = authResult.idToken;
                  this.user = authResult.idTokenPayload;
                  resolve();
               } else if (err) {
                  this.logout();
                  reject(err);
               }
            });
         });
      },
   },
});

export default {
   install: function (Vue) {
      Vue.prototype.$auth = auth;
   },
};
